// extracted by mini-css-extract-plugin
export var chevron = "_ds-4";
export var chevronExpanded = "_ds-5";
export var row = "_ds-0";
export var rowBody = "_ds-6";
export var rowDescription = "_ds-7";
export var rowHeader = "_ds-1";
export var rowTitle = "_ds-2";
export var rowTitleComplete = "_ds-3";